import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tabs } from '../tabs/tabs';
import { FactoryOptions } from './factory_options';
import { StandardFeatures } from './standard_features';

// eslint-disable-next-line valid-jsdoc
/**
 * Renders the AccessoriesContainer component
 * @returns {Node} - Returns a Tab component to toggle between Factory options and standard features
 */
const _AccessoriesContainer = ({ showABTest }) => {
    const options = [
        {
            label: 'Factory Options',
            id: 'factory',
            content: <FactoryOptions />
        },
        {
            label: 'What is fitted as standard?',
            id: 'standard',
            content: <StandardFeatures />
        }
    ];
    const optionsABTest = [
        {
            label: 'Select all options that have been fitted.',
            id: 'factory',
            content: <FactoryOptions />
        },
        {
            label: 'Select to see what is fitted as standard.',
            id: 'standard',
            content: <StandardFeatures />
        }
    ];
    const targetOptions = showABTest ? optionsABTest : options;
    return (
        <Tabs options={targetOptions} />
    );
};
_AccessoriesContainer.propTypes = {
    showABTest: PropTypes.bool
};

/**
 * Maps the store state to component props
 * @param {Immutable.Map} state - The application state
 * @returns {Object} - Required props
 */
const mapStateToProps = (state) => {
    const factoryOptionSplitTest = state.getIn(['page', 'splitTrafficId']) === 'splitFactoryOptions';
    const factoryOptionExpTest = state.getIn(['page', 'experimentId']) === 'expFactoryOptions';
    return {
        showABTest: (factoryOptionSplitTest || factoryOptionExpTest)
    };
};

const AccessoriesContainer = connect(mapStateToProps)(_AccessoriesContainer);
export { _AccessoriesContainer, AccessoriesContainer };
